import Vue from 'vue'

export const ME = (state, me = {}) => {
  state.me = me
}

export const KALEIDERS = (state, data) => {
  state.kaleiders = data
}

export const SET_KALEIDER_DAY_PER_YEAR = (state, data) => {
  const KALEIDER = state.kaleiders.find(item => item.id === data.kaleiderId)
  const YEAR = KALEIDER.daysPerYear.findIndex(
    item => item.year === data.daysPerYear.year
  )

  Vue.set(KALEIDER.daysPerYear, YEAR, data.daysPerYear)

  // Set remaing days for all time
  Vue.set(KALEIDER, 'remainingDays',
    KALEIDER.daysPerYear.reduce(
      (reducer, valorActual) => reducer + valorActual.remainingDays,
      0
    )
  )
}

export const GET_VACATIONS = (state, data) => {
  state.vacations = data
}

export const GET_HOLIDAYS = (state, data) => {
  state.holidays = data
}

export const SET_START_DATE = (state, data) => {
  state.startDate = data
}

export const SET_END_DATE = (state, data) => {
  state.endDate = data
}

export const SET_HOLIDAY_NAME = (state, data) => {
  state.holidayName = data
}

export const SET_SHOW_MORE = (state, data) => {
  state.showMore = data
}

export const SET_API_ERROR = (state, data = false) => {
  state.apiError = data
}

export const SET_CURRENT_VIEW = (state, data) => {
  state.currentView = data
}

export const SET_SELECT_DAY = (state, data) => {
  state.selectDay = data
}

export const SET_SELECT_YEAR = (state, data) => {
  state.selectedYear = data
}

export const SET_IMPORT_HOLIDAYS_SUCCESS = (state, data) => {
  state.importVacationsSuccess = data
}

export const UPDATE_VACATIONS = (state) => {
  let newVacations = [{
    'startDate': state.startDate,
    'endDate': state.endDate,
    'kaleider': {
      'id': state.me.id,
      'name': state.me.name
    }
  }]
  state.newVacations = newVacations
  // total booked days
  let start = new Date(state.startDate)
  let end = new Date(state.endDate)
  let dif = end - start
  let dias = Math.floor(dif / (1000 * 60 * 60 * 24)) + 1

  let bookedDays = 0
  for (let day = 0; day < dias; day++) {
    if (day > 0) {
      start.setDate(start.getDate() + 1)
    } else {
      start.setDate(start.getDate())
    }
    let weekDay = start.getDay()
    // TODO: remove magic number
    if (weekDay > 0 && weekDay < 6) {
      let thisDayEvents = []
      let thisDayPublic = []
      if (state.vacations.length) {
        thisDayEvents = state.vacations.filter(vacations => {
          let dt = new Date(vacations.startDate)
          let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
          let ed =
            vacations.endDate ? new Date(vacations.endDate) : st

          // Fix bug on daylight time saving
          let startUtc = new Date(start)
          startUtc.setHours(0, 0, 0, 0)
          dt.setHours(0, 0, 0, 0)
          st.setHours(0, 0, 0, 0)
          ed.setHours(0, 0, 0, 0)

          return start >= st && start <= ed
        })
      }
      if (state.holidays.length) {
        thisDayPublic = state.holidays.filter(holidays => {
          let dt = new Date(holidays.date)
          let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
          let ed = holidays.date ? new Date(holidays.date) : st

          // Fix bug on daylight time saving
          let startUtc = new Date(start)
          startUtc.setHours(0, 0, 0, 0)
          dt.setHours(0, 0, 0, 0)
          st.setHours(0, 0, 0, 0)
          ed.setHours(0, 0, 0, 0)

          return startUtc >= st && startUtc <= ed
        })
      }
      if (!thisDayEvents.length && !thisDayPublic.length) {
        bookedDays++
      }
    }
  }
  state.bookedDays = bookedDays
}

export const UPDATE_HOLIDAYS = (state) => {
  let newHolidays = [{
    'date': state.startDate
  }]
  state.newHolidays = newHolidays
}

export const ADD_VACATIONS = (state, data) => {
  state.vacations.push(state.newVacations[0])
  state.newVacations = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.updateVacations = true
}

export const ADD_HOLIDAYS = (state, data) => {
  state.holidays.push(state.newHolidays[0])
  state.newHolidays = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.updateHolidays = true
}

export const CANCEL_VACATIONS = (state) => {
  state.newVacations = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.apiError = ''
}

export const CANCEL_HOLIDAYS = (state) => {
  state.newHolidays = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
}

export const CANCEL_REMOVE = (state) => {
  state.newVacations = []
  state.newHolidays = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.editingId = ''
}

export const EDIT_ID = (state, data) => {
  state.editingId = data
}

export const SET_UPDATE_VACATIONS = (state, data) => {
  state.updateVacations = data
}

export const SET_UPDATE_HOLIDAYS = (state, data) => {
  state.updateHolidays = data
}

export const REMOVE_VACATIONS = (state) => {
  state.newVacations = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.editingId = ''
  state.updateVacations = true
}

export const REMOVE_HOLIDAYS = (state) => {
  state.newHolidays = []
  state.startDate = ''
  state.endDate = ''
  state.selectDay = []
  state.bookedDays = 0
  state.showMore = ''
  state.editingId = ''
  state.updateHolidays = true
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js